var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticClass:"quill-container"}),_c('div',{staticClass:"text-right",attrs:{"id":"counter"}}),_c('input',{staticClass:"el-col-0",attrs:{"type":"file","id":"getFile","accept":"image/*"},on:{"change":function($event){return _vm.uploadFunction($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }